
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic/detail/[id]",
      function () {
        return require("private-next-pages/topic/detail/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic/detail/[id]"])
      });
    }
  